var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGazelLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 613.932,
    height: 196.5,
    viewBox: "0 0 613.932 196.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3d75ba;}.b{clip-path:url(#a);}.c{clip-path:url(#b);}.d{clip-path:url(#c);}.e{clip-path:url(#d);}.f{fill:#009d45;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 33.097,
    height: 11.09
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 31.19,
    height: 10.917
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 33.79,
    height: 11.263
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 613.932,
    height: 196.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(276.649 63.074)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 33.097,
    height: 11.09
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(276.649 87.853)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 31.19,
    height: 10.917
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(276.649 114.192)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 33.79,
    height: 11.263
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M218.455,48.912c2.946,2.426,4.505,6.585,4.505,12.476V92.406h-12.3V64.334a11.667,11.667,0,0,0-1.04-5.545Q207.8,55.15,202.86,55.15c-3.985,0-6.931,1.733-8.317,5.2a16.882,16.882,0,0,0-1.213,7.1V92.406H181.2V46.313h11.61v6.758a20.036,20.036,0,0,1,4.332-5.2c2.426-1.906,5.545-2.772,9.357-2.772,5.025,0,9.011,1.213,11.956,3.812",
    transform: "translate(132.784 33.049)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M241.863,47.253a17.676,17.676,0,0,1,7.971,6.758,21.915,21.915,0,0,1,3.639,9.53,46.6,46.6,0,0,1,.347,9.184H220.2c.173,4.679,1.733,7.8,4.852,9.7a11.688,11.688,0,0,0,6.585,1.733,10.488,10.488,0,0,0,6.758-2.079,11.463,11.463,0,0,0,2.426-3.119h12.3a14.272,14.272,0,0,1-4.505,8.317c-4.159,4.505-9.877,6.758-17.328,6.758A25.251,25.251,0,0,1,215,88.32c-4.679-3.812-7.1-9.877-7.1-18.541,0-7.971,2.079-14.209,6.411-18.368,4.159-4.332,9.7-6.411,16.462-6.411a26.885,26.885,0,0,1,11.09,2.253m-18.021,10.4a12.953,12.953,0,0,0-3.292,7.1h20.794c-.173-3.119-1.213-5.718-3.292-7.278a10.139,10.139,0,0,0-7.1-2.426,9.691,9.691,0,0,0-7.1,2.6",
    transform: "translate(152.35 32.976)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M262.945,45.1h1.04V57.4c-.693,0-1.386-.173-2.079-.173H260.52c-4.852,0-8.144,1.56-9.7,4.679a19.129,19.129,0,0,0-1.386,8.144V92.059H237.3V46.14h11.437v7.971c1.906-3.119,3.466-5.2,4.852-6.238,2.253-1.906,5.2-2.772,8.837-2.772h.52",
    transform: "translate(173.894 33.049)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M279.346,46.051a14.1,14.1,0,0,1,7.1,6.758V46.224h11.783V89.891c0,5.892-1.04,10.4-2.946,13.516q-5.2,7.8-19.754,7.8c-5.892,0-10.743-1.213-14.382-3.466-3.812-2.253-5.718-5.718-6.238-10.4h13.169a5.485,5.485,0,0,0,1.733,3.119c1.386,1.04,3.466,1.733,6.585,1.733,4.332,0,7.278-1.386,8.664-4.332,1.04-1.906,1.386-5.025,1.386-9.357V85.559a16.828,16.828,0,0,1-3.812,4.505c-2.426,1.906-5.545,2.772-9.357,2.772-5.891,0-10.743-2.079-14.209-6.238S253.7,76.721,253.7,69.617c0-6.931,1.733-12.649,5.2-17.328s8.317-6.931,14.556-6.931a11.124,11.124,0,0,1,5.892.693m4.159,33.1c1.906-2.079,2.946-5.545,2.946-10.224,0-4.332-.866-7.624-2.772-10.05a9.291,9.291,0,0,0-7.451-3.466,8.583,8.583,0,0,0-8.664,5.892,20.477,20.477,0,0,0-1.213,7.8,18.541,18.541,0,0,0,1.386,7.1,8.866,8.866,0,0,0,8.837,5.892,7.59,7.59,0,0,0,6.931-2.946",
    transform: "translate(185.912 33.139)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M295.2,47.29H282.9V36.2h12.3Zm-12.3,5.372h12.3V98.754H282.9Z",
    transform: "translate(207.31 26.528)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M326.563,47.253a17.676,17.676,0,0,1,7.971,6.758,21.916,21.916,0,0,1,3.639,9.53,46.6,46.6,0,0,1,.347,9.184H304.9c.173,4.679,1.733,7.8,4.852,9.7a11.687,11.687,0,0,0,6.585,1.733,10.488,10.488,0,0,0,6.758-2.079,11.463,11.463,0,0,0,2.426-3.119h12.3a14.272,14.272,0,0,1-4.505,8.317c-4.159,4.505-9.877,6.758-17.328,6.758A25.251,25.251,0,0,1,299.7,88.32c-4.679-3.812-7.1-9.877-7.1-18.541,0-7.971,2.079-14.209,6.411-18.368,4.159-4.332,9.7-6.411,16.462-6.411a26.885,26.885,0,0,1,11.09,2.253m-18.021,10.4a12.953,12.953,0,0,0-3.292,7.1h20.794c-.173-3.119-1.213-5.718-3.292-7.278a10.139,10.139,0,0,0-7.1-2.426,9.691,9.691,0,0,0-7.1,2.6",
    transform: "translate(214.419 32.976)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M80.38,56.54A12.506,12.506,0,0,0,73.1,47.53,18.541,18.541,0,0,0,66,46.143a15.2,15.2,0,0,0-12.3,5.718c-3.292,3.812-4.852,9.53-4.852,17.155s1.733,13.169,5.2,16.288A17.527,17.527,0,0,0,66,90.157c4.332,0,7.971-1.213,10.743-3.812a16.65,16.65,0,0,0,5.2-9.877H67.557v-10.4H93.549V99.514H84.885l-1.386-7.8a34.6,34.6,0,0,1-6.758,6.238,24.022,24.022,0,0,1-12.649,3.119c-8.317,0-15.075-2.946-20.274-8.664C38.272,86.691,35.5,78.72,35.5,68.843c0-10.05,2.772-18.194,8.317-24.259s13-9.184,22.007-9.184c7.971,0,14.382,2.079,19.061,6.065A22.14,22.14,0,0,1,93.2,56.54H80.38Z",
    transform: "translate(26.015 25.941)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M93.387,64.334a31.307,31.307,0,0,0,4.852-1.04,3.63,3.63,0,0,0,2.6-3.466,4.253,4.253,0,0,0-2.079-3.985,13.286,13.286,0,0,0-5.892-1.04c-2.946,0-4.852.693-6.065,2.079a9.157,9.157,0,0,0-1.733,4.159H73.46a16.565,16.565,0,0,1,3.466-9.877c3.119-3.985,8.664-6.065,16.462-6.065A30.969,30.969,0,0,1,106.9,48.046c3.985,2.079,5.892,5.718,5.892,11.437V85.994a7.174,7.174,0,0,0,.693,3.292,4.718,4.718,0,0,0,1.733,1.386v1.733H102.051a7.262,7.262,0,0,1-.693-2.6c-.173-.866-.173-1.733-.347-2.772a37.4,37.4,0,0,1-5.718,4.679,16.785,16.785,0,0,1-8.837,2.253,15.219,15.219,0,0,1-10.4-3.639C73.286,87.9,71.9,84.608,71.9,80.1c0-5.718,2.253-9.7,6.585-12.3,2.426-1.386,5.892-2.426,10.743-2.946Zm7.451,5.545a14.321,14.321,0,0,1-2.253,1.213,28.866,28.866,0,0,1-3.292.866l-2.772.52a17.354,17.354,0,0,0-5.545,1.733c-1.906,1.04-2.772,2.772-2.772,5.2a5.41,5.41,0,0,0,1.733,4.505A7.051,7.051,0,0,0,90.094,85.3a12.447,12.447,0,0,0,7.278-2.253c2.253-1.56,3.292-4.332,3.466-8.317Z",
    transform: "translate(52.689 33.049)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M100.533,55.577V45.7h36.389V55.75L114.4,82.089h23.393v9.877H98.8V82.609l22.873-27.032Z",
    transform: "translate(72.401 33.489)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M156.263,47.253a17.676,17.676,0,0,1,7.971,6.758,21.916,21.916,0,0,1,3.639,9.53,46.6,46.6,0,0,1,.347,9.184H134.6c.173,4.679,1.733,7.8,4.852,9.7a11.688,11.688,0,0,0,6.585,1.733,10.488,10.488,0,0,0,6.758-2.079,11.463,11.463,0,0,0,2.426-3.119h12.3a14.272,14.272,0,0,1-4.505,8.317c-4.159,4.505-9.877,6.758-17.328,6.758A25.251,25.251,0,0,1,129.4,88.32c-4.679-3.812-7.1-9.877-7.1-18.541,0-7.971,2.079-14.209,6.411-18.368,4.159-4.332,9.7-6.411,16.462-6.411a28.13,28.13,0,0,1,11.09,2.253m-18.194,10.4a12.953,12.953,0,0,0-3.292,7.1H155.57c-.173-3.119-1.213-5.718-3.292-7.278a10.139,10.139,0,0,0-7.1-2.426,9.691,9.691,0,0,0-7.1,2.6",
    transform: "translate(89.622 32.976)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 12.13,
    height: 62.381,
    transform: "translate(262.693 63.074)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGazelLogo);
export default __webpack_public_path__ + "static/media/gazel-logo.1e00222c.svg";
export { ForwardRef as ReactComponent };